<div class="dialog-content-wrapper">

    <div fxLayout="row wrap">

          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Profissional</mat-label>
            <input matInput id="application-dashboards-admin-professional-edit-form_ac"
                [matAutocomplete]="autoPerformerF" autocomplete="off" type="search"
                [formControl]="performerCtrl" />
            <mat-autocomplete autoActiveFirstOption #autoPerformerF="matAutocomplete"
                autoActiveFirstOption [displayWith]="displayFn"
                (optionSelected)="performerSelected($event)">
                <mat-option *ngFor="let performer of performerList" [value]="performer">
                    <p *ngIf="performer.professional">
                        {{ performer.professional.person.name }}
                    </p>
                    <p *ngIf="performer.person">
                        {{ performer.person.name }}
                    </p>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <div class="w-100-p" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="0px" fxLayoutGap.lt-md="0px">

            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                fxFlex.gt-sm="50">

                <!-- Front -->
                <div class="fuse-widget-front">

                    <div class="px-16 border-bottom" fxLayout="row wrap" fxLayoutAlign="space-between center">

                        <div fxFlex class="py-16 h3"><b>{{'Plano de Saúde'}}</b></div>

                    </div>


                    <div class="h-400">
                        <ngx-charts-pie-chart *fuseIfOnDom [scheme]="schemePieChart" [results]="dashboardInsuranceList"
                            [doughnut]="true" [legend]="true" [explodeSlices]="false" [labels]="true"
                            [legendTitle]="'Legenda'" [doughnut]="false">
                        </ngx-charts-pie-chart>
                    </div>


                </div>
                <!-- / Front -->

            </fuse-widget>

            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                fxFlex.gt-sm="50">

                <!-- Front -->
                <div class="fuse-widget-front">

                    <div class="px-16 border-bottom" fxLayout="row wrap" fxLayoutAlign="space-between center">

                        <div fxFlex class="py-16 h3"><b>{{'Faixa Étaria'}}</b></div>

                    </div>


                    <div class="h-400">
                        <ngx-charts-pie-chart *fuseIfOnDom [scheme]="schemePieChart" [results]="dashboardAgeRangeList"
                            [doughnut]="true" [legend]="true" [explodeSlices]="false" [labels]="true"
                            [legendTitle]="'Legenda'" [doughnut]="false">
                        </ngx-charts-pie-chart>
                    </div>


                </div>
                <!-- / Front -->

            </fuse-widget>

        </div>

        <div fxLayout="row wrap" fxFlex="100" fxLayoutAlign="space-around center">

            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                fxFlex.gt-xs="50" fxFlex.gt-md="100">
                <!-- Front -->
                <div class="fuse-widget-front">

                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''" [ngClass]="{'h-53': true}"
                        fxLayout="row" fxLayoutAlign="space-between">
                        <div class="h3">
                            <span class="mr-20"><b>{{'Status do Agendamento'}}</b></span>
                            <mat-form-field appearance="outline">
                                <mat-label>Periodo do Agendamento</mat-label>
                                <mat-date-range-input [formGroup]="scheduleStatusGroup" [rangePicker]="picker">
                                    <input matStartDate formControlName="dateStart" placeholder="Data inicio">
                                    <input matEndDate formControlName="dateEnd" placeholder="Data final">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                        </div>

                    </div>

                    <div>
                        <div class="w-100-p" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="0px"
                            fxLayoutGap.lt-md="0px">

                            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                                fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="20">
                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''"
                                        [ngClass]="{'h-53': true}" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="h3">{{'Total de Horários'}}</div>
                                    </div>
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div class="light-blue-fg font-size-72 line-height-72">
                                            {{scheduleStatusValues.total == null ? 0 : scheduleStatusValues.total}}
                                        </div>
                                    </div>
                                </div>
                                <!-- / Front -->
                            </fuse-widget>
                            <!-- ---------------------------------------------PRIMEIRO WIDGET----------------------------------------------------------------------- -->
                            <!-- ---------------------------------------------SEGUNDO WIDGET----------------------------------------------------------------------- -->
                            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                                fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="20">
                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''"
                                        [ngClass]="{'h-53': true}" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="h3">{{'Horários Livres'}}</div>
                                    </div>
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div class="red-fg font-size-72 line-height-72">
                                            {{scheduleStatusValues.free == null ? 0 : scheduleStatusValues.free}}
                                        </div>
                                    </div>
                                </div>
                                <!-- / Front -->
                            </fuse-widget>
                            <!-- ---------------------------------------------SEGUNDO WIDGET----------------------------------------------------------------------- -->
                            <!-- ---------------------------------------------TERCEIRO WIDGET----------------------------------------------------------------------- -->
                            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                                fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="20">
                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''"
                                        [ngClass]="{'h-53': true}" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="h3">{{'Cancelados'}}</div>
                                    </div>
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div class="orange-fg font-size-72 line-height-72">
                                            {{scheduleStatusValues.cancel == null ? 0 : scheduleStatusValues.cancel}}
                                        </div>
                                    </div>
                                </div>
                                <!-- / Front -->
                            </fuse-widget>
                            <!-- ---------------------------------------------TERCEIRO WIDGET----------------------------------------------------------------------- -->
                            <!-- ---------------------------------------------QUARTO WIDGET----------------------------------------------------------------------- -->
                            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                                fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="20">
                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''"
                                        [ngClass]="{'h-53': true}" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="h3">{{'Agendados'}}</div>
                                    </div>
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div class="blue-grey-fg font-size-72 line-height-72">
                                            {{scheduleStatusValues.done == null ? 0 : scheduleStatusValues.done}}
                                        </div>
                                    </div>
                                </div>
                                <!-- / Front -->
                            </fuse-widget>
                            <!-- ---------------------------------------------QUARTO WIDGET----------------------------------------------------------------------- -->
                            <!-- ---------------------------------------------QUINTO WIDGET----------------------------------------------------------------------- -->
                            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                                fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="20">
                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''"
                                        [ngClass]="{'h-53': true}" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="h3">{{'Outros'}}</div>
                                    </div>
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div class="green-fg font-size-72 line-height-72">
                                            {{scheduleStatusValues.oters == null ? 0 : scheduleStatusValues.oters}}
                                        </div>
                                    </div>
                                </div>
                                <!-- / Front -->
                            </fuse-widget>
                        </div>
                    </div>
                </div>
                <!-- / Front -->
            </fuse-widget>
        </div>

        <div fxLayout="row wrap" fxFlex="100" fxLayoutAlign="space-around center">

            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                fxFlex.gt-xs="50" fxFlex.gt-md="100">
                <!-- Front -->
                <div class="fuse-widget-front">

                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''" [ngClass]="{'h-53': true}"
                        fxLayout="row" fxLayoutAlign="space-between">
                        <div class="h3" fxLayout="row" fxLayout.lt-md="column">

                            <span class="mr-20"><b>{{'Agenda X Evolução'}}</b></span>

                            <mat-form-field class="mr-20" appearance="outline">
                                <mat-label>Periodo do Agendamento</mat-label>
                                <mat-date-range-input [formGroup]="scheduleAnamneseGroup"
                                    [rangePicker]="pickerScheduleAnamnese">
                                    <input matStartDate formControlName="dateStart" placeholder="Data inicio">
                                    <input matEndDate formControlName="dateEnd" placeholder="Data final">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="pickerScheduleAnamnese"></mat-datepicker-toggle>
                                <mat-date-range-picker #pickerScheduleAnamnese></mat-date-range-picker>
                            </mat-form-field>

                            <button *ngIf="scheduleAnamneseDetailValues.length > 0" mat-raised-button
                                (click)="datailScheduleAnamneseList()">Listar comparativo</button>
                        </div>

                    </div>

                    <div>
                        <div class="w-100-p" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="0px"
                            fxLayoutGap.lt-md="0px" fxLayoutAlign="space-evenly ">

                            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                                fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="20">
                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''"
                                        [ngClass]="{'h-53': true}" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="h3">{{'Agendados'}}</div>
                                    </div>
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div class="light-blue-fg font-size-72 line-height-72">
                                            {{scheduleAnamneseValues.scheduleDone == null ? 0 :
                                            scheduleAnamneseValues.scheduleDone}}
                                        </div>
                                    </div>
                                </div>
                                <!-- / Front -->
                            </fuse-widget>
                            <!-- ---------------------------------------------PRIMEIRO WIDGET----------------------------------------------------------------------- -->
                            <!-- ---------------------------------------------SEGUNDO WIDGET----------------------------------------------------------------------- -->
                            <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                                fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-md="20">
                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div class="pl-16 pr-8 py-16 border-bottom" [ngClass.lt-md]="''"
                                        [ngClass]="{'h-53': true}" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="h3">{{'Evoluções'}}</div>
                                    </div>
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div class="red-fg font-size-72 line-height-72">
                                            {{scheduleAnamneseValues.documentDone == null ? 0 :
                                            scheduleAnamneseValues.documentDone}}
                                        </div>
                                    </div>
                                </div>
                                <!-- / Front -->
                            </fuse-widget>
                            <!-- ---------------------------------------------SEGUNDO WIDGET----------------------------------------------------------------------- -->

                            <!-- ---------------------------------------------HD E FULL HD----------------------------------------------------------------------- -->
                            <div *ngIf="datailScheduleAnamnese" #targetDiv class="w-100-p" fxLayout="row wrap"
                                fxLayout.lt-md="column" fxLayoutGap="0px" fxLayoutGap.lt-md="0px"
                                fxLayoutAlign="space-evenly center" fxHide.lt-lg>

                                <mat-accordion class="w-100-p">
                                    <mat-expansion-panel
                                        [ngStyle]="{'background-color': scheduleAnamnese.documentDate ? '' : '#de8686'}"
                                        hideToggle
                                        *ngFor="let scheduleAnamnese of scheduleAnamneseDetailValues let i = index">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title class="w-30-p">
                                                {{scheduleAnamnese.patientName}}
                                            </mat-panel-title>
                                            <mat-panel-description  fxLayoutAlign="start center" class="w-80-p">
                                                <span style="margin-right: 15px;">
                                                    <b>Data do Agendamento:</b> {{scheduleAnamnese.scheduleDate | date
                                                    :'dd/MM/yyyy'}} {{" "}}
                                                </span>

                                                <span>
                                                    <ng-container *ngIf="scheduleAnamnese.documentDate">
                                                        <b>Data da Evolução:</b>
                                                        {{ scheduleAnamnese.documentDate | date :'dd/MM/yyyy' }}
                                                    </ng-container>
                                                </span>

                                                <button fxFlex="none" style="margin-left: auto;" mat-icon-button (click)="openAddDocument(scheduleAnamnese)" matTooltip="Abrir Evolução">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel>
                                    </mat-expansion-panel>
                                </mat-accordion>

                                <mat-paginator *ngIf="scheduleAnamneseDetailValues.length > 0"
                                    fxLayoutAlign="center end" #paginator showFirstLastButtons stickyEnd
                                    [length]="totalElements" [pageIndex]="pagina" [pageSizeOptions]="[5,10]"
                                    (page)="getDashboardScheduleAnamneseByPerformerDetail($event,'page')"></mat-paginator>


                            </div>

                            <!-- ---------------------------------------------MOBILE----------------------------------------------------------------------- -->
                            <div *ngIf="datailScheduleAnamnese" #targetDiv class="w-100-p" fxLayout="row wrap"
                                fxLayout.lt-md="column" fxLayoutGap="0px" fxLayoutGap.lt-md="0px"
                                fxLayoutAlign="space-evenly center" fxHide.gt-md>

                                <mat-accordion class="w-100-p">
                                    <mat-expansion-panel
                                        [ngStyle]="{'background-color': scheduleAnamnese.documentDate ? '' : '#de8686'}"
                                        hideToggle
                                        *ngFor="let scheduleAnamnese of scheduleAnamneseDetailValues let i = index">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title class="w-100-p">
                                                {{scheduleAnamnese.patientName}}
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <span>
                                            <b>Data do Agendamento:</b> {{scheduleAnamnese.scheduleDate | date
                                            :'dd/MM/yyyy'}} {{" "}}
                                        </span>

                                        <span>
                                            <ng-container *ngIf="scheduleAnamnese.documentDate">
                                                <b>Data da Evolução:</b>
                                                {{ scheduleAnamnese.documentDate | date :'dd/MM/yyyy' }}
                                            </ng-container>
                                        </span>
                                    </mat-expansion-panel>
                                </mat-accordion>

                                <mat-paginator *ngIf="scheduleAnamneseDetailValues.length > 0"
                                    fxLayoutAlign="center end" #paginator showFirstLastButtons stickyEnd
                                    [length]="totalElements" [pageIndex]="pagina" [pageSizeOptions]="[5,10]"
                                    (page)="getDashboardScheduleAnamneseByPerformerDetail($event,'page')"></mat-paginator>


                            </div>
                        </div>
                    </div>
                </div>
                <!-- / Front -->
            </fuse-widget>
        </div>
    </div>
</div>